export default __webpack_public_path__ + "static/atlassian-ai-c53cd55e54f40fb88ce2c58a1c1bba9345c8bf0c082d6be061c8b7e3eb1cee19.png";